import React, { useCallback, useContext } from 'react';

import isServer from 'src/common/isServer';
import { MainHeaderHeightContext } from 'src/modules/MainContainer/Context';

export function useScrollToRef() {
  const mainHeaderHeight = useContext(MainHeaderHeightContext);

  return useCallback(
    (ref: React.RefObject<HTMLElement>, behavior?: ScrollBehavior) => {
      if (isServer || !ref || !ref.current) {
        return;
      }

      window.scroll({
        top:
          window.scrollY +
          ref.current.getBoundingClientRect().top -
          mainHeaderHeight,
        behavior,
      });
    },
    [mainHeaderHeight]
  );
}
